import { NavLink, Outlet, useLocation } from 'react-router-dom'
import { ROUTE_PATHS } from 'core/constants/routePath'

export const DebugLayout = () => {
  const { pathname } = useLocation()
  const requetesActive =
    pathname === ROUTE_PATHS.IADOCS_DEBUG ||
    pathname.startsWith(`${ROUTE_PATHS.IADOCS_DEBUG}/requetes`)

  return (
    <div className="iadocs-debug-shell">
      <aside className="iadocs-debug-sidebar">
        <nav aria-label="Debug IADocs">
          <NavLink
            to={ROUTE_PATHS.IADOCS_DEBUG}
            className={`debug-side-link${requetesActive ? ' is-active' : ''}`}
          >
            Requêtes
          </NavLink>
          <NavLink
            to={`${ROUTE_PATHS.IADOCS_DEBUG}/documents`}
            className={({ isActive }) =>
              `debug-side-link${isActive ? ' is-active' : ''}`
            }
          >
            Documents S3
          </NavLink>
        </nav>
      </aside>
      <div className="iadocs-debug-main">
        <Outlet />
      </div>
    </div>
  )
}
